var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96142(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-142-1{fill:none;}.cls-96-142-2{fill:none;stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-142-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M20.61,29.88V44c0,3.86,5.69,7,12.72,7S46,47.84,46,44V29.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M20.61,37.29v14.1c0,3.86,5.69,7,12.72,7S46,55.25,46,51.39V37.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M20.61,44.69V58.8c0,3.86,5.69,7,12.72,7S46,62.66,46,58.8V44.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M20.61,52.1V66.21c0,3.86,5.69,7,12.72,7S46,70.07,46,66.21V52.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-96-142-2",
    cx: 33.33,
    cy: 29.47,
    rx: 12.72,
    ry: 5.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M46,37.42c0,3.19-5.69,5.77-12.71,5.77s-12.72-2.58-12.72-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M52.9,44.69V58.8c0,3.86,5.7,7,12.72,7s12.72-3.13,12.72-7V44.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M52.9,52.1V66.21c0,3.86,5.7,7,12.72,7s12.72-3.13,12.72-7V52.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-96-142-2",
    cx: 65.62,
    cy: 44.29,
    rx: 12.72,
    ry: 5.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-142-2",
    d: "M78.34,52.24c0,3.19-5.7,5.77-12.72,5.77S52.9,55.43,52.9,52.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96142);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_142.b82be0312a59eb912b9edc601692595d.svg";
export { ForwardRef as ReactComponent };